/** Parse EUR input into integer cents. Grouping separators are intentionally
 * rejected: a single comma or dot may only be the decimal separator. */
export function centsFromInput(value: string): number | null {
  const input = value.trim();
  if (!input) return null;
  if (!/^\d+(?:[.,]\d{1,2})?$/.test(input)) return null;
  const amount = Number(input.replace(",", "."));
  return Number.isFinite(amount) ? Math.round(amount * 100) : null;
}

export function moneyInput(value?: number | null): string {
  return value == null ? "" : (value / 100).toFixed(2);
}
